/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext } from 'react'

type ContextState = {
  isNewTicketModalOpen: boolean
  setIsNewTicketModalOpen: (newstate: boolean) => void
}

const initialState = {
  isNewTicketModalOpen: false,
  setIsNewTicketModalOpen: () => {},
}

const HandleNewTicketModalContext = React.createContext<ContextState>(initialState)

export function HandleNewTicketModalProvider({ children }: { children: React.ReactNode }) {
  const [isNewTicketModalOpen, setIsNewTicketModalOpen] = useState<boolean>(false)

  return (
    <HandleNewTicketModalContext.Provider value={{ isNewTicketModalOpen, setIsNewTicketModalOpen }}>
      {children}
    </HandleNewTicketModalContext.Provider>
  )
}

export function useHandleNewTicketModal(): ContextState {
  const context = useContext(HandleNewTicketModalContext)
  if (!context)
    throw Error(
      'This hook can only be used under the HandleNewTicketModalContextProvider component',
    )
  return context
}
